
export default {
  data: () => ({
    loading: false,
    overlay_opacity: "0.5",
  }),
  methods: {
    start () {
      this.loading = true
    },
    finish () {
      this.loading = false
    }
  }
}
